import { useEffect, useState } from 'react';

const AVERAGE_ESTIMATION = 15 * 1000;

const steps = {
  analyzing: [
    'Analyzing your Risk Factors',
    'Calculating your lifetime Risk Score',
    'Generating your personalized Action Plan',
    'Developing your annual Testing Plan',
    'Finalizing updates',
  ],
  recalibrating: [
    'Recalibrating your Risk Score',
    'Analyzing your Risk Factors',
    'Updating your personalized recommendations',
    'Finalizing updates',
  ],
};

function checkImage(isCalculationComplete: boolean, currentStep: number, index: number) {
  if (isCalculationComplete || index < currentStep) {
    return '/images/circle-check-filled.svg';
  }
  return '/images/circle-check.svg';
}

function getTextStyles(isCalculationComplete: boolean, currentStep: number, index: number) {
  if (isCalculationComplete || index < currentStep) {
    return {
      textStyle: 'text-body-medium',
      color: 'text-light',
    };
  }
  return {
    textStyle: 'text-body-regular',
    color: 'text-secondary-negative',
  };
}

export default function useProgressStepListController(isFirstTimeLoadingResults: boolean) {
  const stepsList = isFirstTimeLoadingResults ? steps.analyzing : steps.recalibrating;

  const [currentStep, setCurrentStep] = useState(0);

  function startStepProgression(setCurrentStep: (step: number) => void, stepsListLength: number) {
    const stepInterval = AVERAGE_ESTIMATION / stepsListLength;

    const timeouts = Array.from({ length: stepsListLength }).map((_, index) =>
      setTimeout(() => setCurrentStep(index + 1), stepInterval * (index + 1))
    );

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }

  useEffect(() => {
    const clearSteps = startStepProgression(setCurrentStep, stepsList.length);
    return () => clearSteps();
  }, []);

  return { getTextStyles, checkImage, stepsList, currentStep };
}
